// CLOSd Pricing — $59/mo includes 1 seat, +$20/mo per additional seat
const PRICING_CONFIG = {
  basePrice: 59,       // $59/month — includes 1 seat
  perSeatPrice: 20,    // $20/month per additional seat (2nd member onward)

  // Founding 100 — first 100 paying orgs get locked-in pricing
  founding100: {
    maxSlots: 100,
    lockedBasePrice: 59,
    lockedPerSeatPrice: 20,
  },

  // Org statuses (used for display + MRR calculations)
  statuses: {
    trial:     { label: 'Trial',     color: '#D69E2E' },
    active:    { label: 'Active',    color: '#75BB2E' },
    founding:  { label: 'Founding 100', color: '#805AD5' },
    cancelled: { label: 'Cancelled', color: '#E53E3E' },
  },
};

export default PRICING_CONFIG;